var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7023 20.2232L35.8876 18.5709L28.8111 2.13876C28.3156 0.98817 26.6842 0.98817 26.1888 2.13876L19.1124 18.5711L1.29768 20.2232C0.0503036 20.3389 -0.453826 21.8904 0.487295 22.7171L13.9285 34.5251L9.99497 51.9785C9.71954 53.2006 11.0393 54.1594 12.1164 53.5198L27.5 44.3853L42.8835 53.5198C43.9606 54.1594 45.2805 53.2006 45.0051 51.9785L41.0714 34.5251L54.5127 22.7171C55.4538 21.8904 54.9496 20.3389 53.7023 20.2232Z",
    fill: "#FFDC64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8111 2.13876C28.3157 0.988169 26.6843 0.988169 26.1888 2.13876L19.1124 18.5711L1.29769 20.2232C0.0503037 20.3389 -0.453827 21.8904 0.487296 22.7171L13.9286 34.5252L9.99499 51.9786C9.71956 53.2007 11.0393 54.1595 12.1165 53.5199L15.55 51.4812C16.0252 31.9195 25.1142 18.1441 32.3102 10.2637L28.8111 2.13876Z",
    fill: "#FFC850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c445bac2851fa241ed1b002802ea8ed0.svg";
export { ForwardRef as ReactComponent };